import { lazy, Suspense } from "react"

import { Skeleton } from "@/atoms"
import { useEvpTabAvailability } from "./useEvpTabAvailability"

import type { ComponentType } from "react"
import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

// Shared wrapper for the demo-only EVP tabs (Exploit Validation, Remediation):
// lazy-loads the heavy view — and its deps — as its own chunk, kept out of the
// bundle for tenants that never see these tabs (gated by auth.isDemo()), and
// gates tab availability on exploitability data.
export const makeLazyEvpTab = (
  tabName: string,
  load: () => Promise<{ default: ComponentType<TabComponentProps> }>
) => {
  const View = lazy(load)

  const LazyEvpTab = (props: TabComponentProps) => {
    useEvpTabAvailability(tabName, props.record?.id, props.actions)

    return (
      <Suspense fallback={<Skeleton active />}>
        <View {...props} />
      </Suspense>
    )
  }

  return LazyEvpTab
}
